import { atom } from "recoil";

const isAppAtom = atom({
    key: 'isApp',
    default: null
})

export default isAppAtom